import { SxProps } from '@mui/material';
import { greenDefault, grey, grey13Opacity60 } from 'app/components/ThemeProvider/colors';

export const dialogTitle: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: '28px',
  padding: '40px 40px',
  paddingBottom: '0px',
};

export const closeBtn: SxProps = {
  position: 'absolute',
  top: '32px',
  right: '32px',
  padding: '10px',
  minWidth: '36px',
  height: '36px',
  width: '36px',
  borderRadius: '8px',
  alignItems: 'centre',

  '& .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
};
export const dialogContent: SxProps = {
  display: 'flex',
  padding: '0px',
  flexDirection: 'column',
  gap: '20px',
  overflow: 'auto',
};

export const secondaryText: SxProps = {
  fontSize: '17px',
  color: grey13Opacity60,
};
export const amountText: SxProps = {
  fontSize: '20px',
  color: greenDefault,
  fontWeight: '600',
};
export const dialogContentBoxes: SxProps = { display: 'flex', flexDirection: 'column', gap: '8px', pr: '35px' };

export const inputOutlined: SxProps = {
  fontSize: '16px',
  fontWeight: 400,
  height: '48px',
  paddingLeft: '16px',
  borderWidth: '1px',
  borderRadius: '8px',
  '& .MuiInputBase-input::placeholder': {
    fontSize: '16px',
    fontWeight: '400px',
    color: 'rgba(20, 25, 31, 0.4)',
  },

  '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: grey,
    borderWidth: '0.5px',
  },
};

export const btnsBox: SxProps = {
  display: 'flex',
  gap: '12px',
  marginTop: '7px',
  padding: 0,
  flexDirection: 'row',
};

export const tableRowStyle: SxProps = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  p: '0 28px',
  gap: '15px',
};

export const tableCell: SxProps = {
  p: '21px 0',
  border: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
};

export const tableCellStatus: SxProps = {
  p: '21px 0',
  border: 'none',
  display: 'flex',
  gap: '15px',
  alignItems: 'center',
  width: '185px',
};

export const tableHeaderCell: SxProps = {
  p: '21px 0',
  border: 'none',
  width: '380px',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
  wordWrap: 'break-word',

  '&:nth-of-type(2)': {
    width: '400px',
  },

  '&:nth-of-type(3)': {
    width: '150px',
  },

  '&:nth-of-type(4)': {
    width: '150px',
  },
};
